'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var fonts = require('../../constants/fonts.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Table = (_a) => {
  var _b = _a, { text, children } = _b, rest = __objRest(_b, ["text", "children"]);
  if (children) {
    return /* @__PURE__ */ jsxRuntime.jsx(StyledTable, __spreadProps(__spreadValues({}, rest), {
      children
    }));
  }
  return /* @__PURE__ */ jsxRuntime.jsx(StyledTable, __spreadProps(__spreadValues({}, rest), {
    dangerouslySetInnerHTML: { __html: text }
  }));
};
const StyledTable = styled__default["default"].div(
  ({
    commonStyle,
    color,
    backgroundColor,
    borderColor,
    headerBackgroundColor
  }) => `
    ${coreRenderer.getStyle(commonStyle)};
    ${fonts.getCommonTextCss()}
    overflow-x: auto;
    color: ${color || "inherit"};
    background-color: ${backgroundColor || "inherit"};

    table {
      border-collapse: collapse;
      margin: 0;
      overflow: hidden;
      table-layout: fixed;
      min-width: 100%;
    }
    table td, table th {
      border: 2px solid ${borderColor || "#ced4da"};
      box-sizing: border-box;
      min-width: 1em;
      padding: 3px 5px;
      position: relative;
      vertical-align: top;
    }
    table td > *, table th > * {
      margin-bottom: 0;
    }
    table th {
      background-color: ${headerBackgroundColor || "#f1f3f5"};
      font-weight: bold;
      text-align: left;
    }
    table .selectedCell:after {
      background: rgba(200, 200, 255, 0.4);
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      pointer-events: none;
      position: absolute;
      z-index: 2;
    }
    table .column-resize-handle {
      background-color: #adf;
      bottom: -2px;
      position: absolute;
      right: -2px;
      pointer-events: none;
      top: 0;
      width: 4px;
    }
    table p {
      margin: 0;
    }
    .tableWrapper {
      padding: 1rem 0;
      overflow-x: auto;
    }
    .resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }   
  `
);
Table.displayName = "Table";

exports.StyledTable = StyledTable;
exports.Table = Table;
